var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08631 2.01175H14.7379C14.9421 2.01175 15.1375 2.09503 15.279 2.24235L20.344 7.51835C20.4781 7.65802 20.5529 7.84413 20.5529 8.03775V17.2012C20.5693 19.7005 18.6014 21.7628 16.1043 21.8641C16.0942 21.8645 16.0841 21.8647 16.0739 21.8647H8.09496C8.07017 21.8653 8.04846 21.8652 8.03278 21.8651C8.00893 21.8649 8.00482 21.8647 7.99293 21.8647L7.97625 21.8646C5.45197 21.8084 3.4506 19.719 3.50093 17.1959V6.49075L3.50114 6.47308C3.55976 3.98595 5.59883 2.00298 8.08631 2.01175ZM5.00093 6.50006V17.2037L5.00075 17.2201C4.9638 18.9175 6.30804 20.3243 8.00451 20.3648L8.02367 20.3649L8.04508 20.3651L8.05724 20.3652C8.05987 20.3652 8.06087 20.3651 8.06075 20.3651C8.06881 20.3649 8.07687 20.3647 8.08493 20.3647H16.0579C17.7411 20.2888 19.065 18.8957 19.0529 17.2091L19.0529 17.2037L19.0529 8.33948L14.4183 3.51175H8.08204C6.41299 3.50533 5.04466 4.8336 5.00093 6.50006Z",
    fill: "#0038FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4746 2C14.8888 2 15.2246 2.33579 15.2246 2.75V5.659C15.2246 6.66521 16.0375 7.48066 17.0438 7.484H19.7976C20.2118 7.484 20.5476 7.81979 20.5476 8.234C20.5476 8.64821 20.2118 8.984 19.7976 8.984H17.0426L17.0405 8.984C15.2072 8.97883 13.7246 7.49248 13.7246 5.659V2.75C13.7246 2.33579 14.0604 2 14.4746 2Z",
    fill: "#0038FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13867 15.3594C8.13867 14.9452 8.47446 14.6094 8.88867 14.6094H14.2887C14.7029 14.6094 15.0387 14.9452 15.0387 15.3594C15.0387 15.7736 14.7029 16.1094 14.2887 16.1094H8.88867C8.47446 16.1094 8.13867 15.7736 8.13867 15.3594Z",
    fill: "#0038FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13672 11.6055C8.13672 11.1913 8.47251 10.8555 8.88672 10.8555H12.2427C12.6569 10.8555 12.9927 11.1913 12.9927 11.6055C12.9927 12.0197 12.6569 12.3555 12.2427 12.3555H8.88672C8.47251 12.3555 8.13672 12.0197 8.13672 11.6055Z",
    fill: "#0038FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.962e40de28a4fbb54a6e0e8e47263238.svg";
export { ForwardRef as ReactComponent };